module.exports = __webpack_public_path__ + "static/media/metafest-header.673f95f8.png";